import React, { useState} from "react";
import StatusButton from "./status-button";
import ReviewPopup from "../../Pages/kycs/review-popup";

export default function FileUploadDisplay({ label, fileData, onFileClick,disabled=false
 }) {
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  //  Normalize fileData.value into an array
const files = Array.isArray(fileData?.value)
  ? fileData.value
  : fileData?.value != null
  ? [fileData.value]
  : [];
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  return (
    <div className="space-y-3">
      {/* Label and status section */}
      <div className="flex items-center justify-between">
        <label className="whitespace-normal break-words text-sm w-40 md:w-full text-[#A6A6A6] flex items-center">
          {label}
        </label>

        <StatusButton
          status={fileData?.status}
          count={fileData?.comments?.length}
          disabled={disabled}
          openSection={() =>
            handleStatusClick(fileData, label, files[0], "file")
          }
        />
      </div>

      {/* File display section */}
      {files.length > 0 &&
        files.map((file, index) => (
          <div
            key={index}
            onClick={(e) => {
              e.preventDefault();
              onFileClick?.(file);
            }}
            className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2 hover:bg-gray-50"
          >
            <div className="flex flex-col">
              <span className="text-black underline break-all">
                {file.file_name || "Unnamed File"}
              </span>
            </div>
          </div>
        ))}
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
}